import React from 'react';
import { motion } from 'framer-motion';
export function CollectionSection() {
  return <section id="collection" className="w-full py-24 px-6 md:px-12" data-id="element-25">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-12 md:gap-20" data-id="element-26">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        x: -40
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        ease: [0.16, 1, 0.3, 1]
      }} className="w-full md:w-1/2 order-2 md:order-1" data-id="element-27">
          <h2 className="font-syncopate font-bold text-4xl md:text-5xl text-black tracking-widest mb-6" data-id="element-28">
            THE COLLECTION
          </h2>
          <div className="space-y-6 text-black/80 font-light leading-relaxed text-lg mb-10" data-id="element-29">
            <p data-id="element-30">
              An obsessively curated library of over 500 shades, finishes, and
              textures.
            </p>
            <p data-id="element-31">
              From our proprietary holographic dusts to imported Japanese gels,
              every bottle on our wave-form display wall has been selected for
              its superior pigment, longevity, and visual impact.
            </p>
          </div>
          <button className="bg-black text-white font-semibold text-sm tracking-widest uppercase px-8 py-4 rounded-full hover:bg-black/80 transition-colors" data-id="element-32">
            Explore Shades
          </button>
        </motion.div>

        {/* Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1.2,
        ease: [0.16, 1, 0.3, 1]
      }} className="w-full md:w-1/2 order-1 md:order-2" data-id="element-33">
          <div className="relative rounded-[2.5rem] overflow-hidden shadow-2xl aspect-[4/5] md:aspect-square" data-id="element-34">
            <img src="https://cdn.magicpatterns.com/uploads/uD9kJNuF5VhakJJrnUSpXv/imagen_5.jpg" alt="Nail Polish Wall Display" className="w-full h-full object-cover" data-id="element-35" />
            {/* Subtle glass overlay on image edge */}
            <div className="absolute inset-0 bg-gradient-to-l from-transparent to-white/10 mix-blend-overlay" data-id="element-36" />
          </div>
        </motion.div>
      </div>
    </section>;
}